module.exports = __webpack_public_path__ + "images/c762c30.png";